"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ImportInvoices = class ImportInvoices extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    file;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    result;
    formats;
    format;
    async $$load_format() {
        return this.formats[0].value;
    }
    ux;
    b_7315092382398562_modalBindings;
    b_4823665167724729_validation;
    dataMembers = ['file', 'formId', 'formName', 'result', 'formats', 'format', 'ux', 'b_7315092382398562_modalBindings', 'b_4823665167724729_validation'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                file: null,
                formId: null,
                formName: "ImportInvoices",
                result: null,
                formats: [{
                        value: "szamlazz_hu_csv",
                        text: this.$fn.pgettext("ImportInvoicesFormat", "Szamlazz.hu CSV"),
                        accept: ".csv",
                    },
                    {
                        value: "ubl_xml",
                        text: this.$fn.pgettext("ImportInvoicesFormat", "UBL XML"),
                        accept: ".xml",
                    },
                ],
                format: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
                b_4823665167724729_validation: ["ext:xlsx",
                    "required",
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("ImportInvoices|Title", "Import Invoices"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3196_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_648747096704084_setData_3202_getActionArgs($event) {
        return {
            path: "result",
            value: $event.data.response.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_648747096704084_request_3200_getActionArgs($event) {
        return {
            operation: "create_invoices_from_file",
            data: { file: this.file, format: this.format },
            contentType: "multipart/form-data",
        };
    }
    async evh_648747096704084_submit(event, scope) {
        return await this.actions.evh_648747096704084_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_3204_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3196 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3196_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3195 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3196,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3195],
        });
        const act_2248226175642056_closeComponent_3198 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3197 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3198,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3197],
        });
        const act_648747096704084_setData_3202 = new core_1.actions.SetDataAction({
            actionArgs: this.act_648747096704084_setData_3202_getActionArgs,
            events: [],
        });
        const evh_648747096704084_success_3201 = new core_1.actions.EventHandlerImpl({
            action: act_648747096704084_setData_3202,
            event: "success",
            displayName: "setData",
        });
        const act_648747096704084_request_3200 = new core_1.actions.RequestAction({
            actionArgs: this.act_648747096704084_request_3200_getActionArgs,
            displayName: "submit",
            events: [evh_648747096704084_success_3201],
        });
        const evh_648747096704084_submit_3199 = new core_1.actions.EventHandlerImpl({
            action: act_648747096704084_request_3200,
            event: "submit",
            displayName: "submit",
        });
        const evh_648747096704084_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_648747096704084_submit_3199],
        });
        const act_1419464017721962_closeModal_3204 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_3204_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_3203 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_3204,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_3203],
        });
        return {
            act_7315092382398562_closeModal_3196,
            evh_7315092382398562_close_3195,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3198,
            evh_2248226175642056_close_3197,
            evh_2248226175642056_close,
            act_648747096704084_setData_3202,
            evh_648747096704084_success_3201,
            act_648747096704084_request_3200,
            evh_648747096704084_submit_3199,
            evh_648747096704084_submit,
            act_1419464017721962_closeModal_3204,
            evh_1419464017721962_clickPreventStop_3203,
            evh_1419464017721962_clickPreventStop,
            submit: act_648747096704084_request_3200,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], ImportInvoices.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ImportInvoices.prototype, "onSize", null);
ImportInvoices = __decorate([
    (0, vue_property_decorator_1.Component)()
], ImportInvoices);
exports.default = ImportInvoices;
vue_property_decorator_1.Vue.component("ImportInvoices", ImportInvoices);
